<template>
  <div class="design-bento">
    <front-page-design-nav theme="light" />

    <section class="hero">
      <img :src="logo" alt="BOX21" class="hero__logo" />
      <h1>{{ hero.line1 }} {{ hero.line2 }}</h1>
      <p>{{ hero.line3 }}</p>
    </section>

    <section class="bento">
      <article class="bento__cell bento__cell--hero">
        <img :src="heroImage" alt="" class="bento__bg" />
        <div class="bento__overlay">
          <span class="bento__label">Live annotations</span>
          <p>Bounding boxes on real wildlife imagery</p>
        </div>
      </article>

      <article v-for="pillar in pillars" :key="pillar.id" class="bento__cell bento__cell--feature">
        <img :src="pillar.icon" :alt="pillar.title" class="bento__icon" />
        <h3>{{ pillar.title }}</h3>
        <div class="bento__tags">
          <span v-for="tag in pillar.tags" :key="tag">{{ tag }}</span>
        </div>
      </article>

      <article class="bento__cell bento__cell--wide">
        <img :src="showcase[0].image" :alt="showcase[0].title" />
        <div class="bento__caption">
          <h3>{{ showcase[0].title }}</h3>
          <p>{{ showcase[0].text }}</p>
        </div>
      </article>

      <article class="bento__cell bento__cell--cta">
        <h3>Ready to build?</h3>
        <button type="button" class="bento__btn" @click="goToRegister">Start free</button>
      </article>

      <article class="bento__cell bento__cell--stat">
        <span class="bento__stat-num">4</span>
        <span class="bento__stat-label">Model types</span>
      </article>
    </section>

    <front-page-design-footer theme="light" />
  </div>
</template>

<script>
import FrontPageDesignNav from '@/components/front_page/designs/FrontPageDesignNav.vue'
import FrontPageDesignFooter from '@/components/front_page/designs/FrontPageDesignFooter.vue'
import { BRAND, HERO, PILLARS, SHOWCASE, HERO_IMAGE } from '@/components/front_page/designs/shared'

export default {
  name: 'DesignBento',
  components: { FrontPageDesignNav, FrontPageDesignFooter },
  data() {
    return {
      logo: BRAND.logo,
      hero: HERO,
      pillars: PILLARS,
      showcase: SHOWCASE,
      heroImage: HERO_IMAGE,
    }
  },
  methods: {
    goToRegister() { this.$router.push({ path: '/login', query: { tab: 'register' } }) },
  },
}
</script>

<style scoped>
.design-bento {
  min-height: 100vh;
  background: #fafafa;
  color: #1a1a1a;
  font-family: system-ui, sans-serif;
}

.hero {
  text-align: center;
  padding: 32px 24px 48px;
  max-width: 640px;
  margin: 0 auto;
}

.hero__logo {
  height: 40px;
  margin-bottom: 24px;
}

.hero h1 {
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 800;
  margin: 0 0 12px;
  letter-spacing: -0.03em;
}

.hero p {
  font-size: 1.2rem;
  color: #0677b9;
  font-weight: 600;
  margin: 0;
}

.bento {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(160px, auto);
  gap: 16px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px 80px;
}

.bento__cell {
  border-radius: 20px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e8e8e8;
  padding: 24px;
  position: relative;
}

.bento__cell--hero {
  grid-column: span 2;
  grid-row: span 2;
  padding: 0;
  min-height: 320px;
}

.bento__bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  inset: 0;
}

.bento__overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));
  color: #fff;
}

.bento__label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  opacity: 0.8;
}

.bento__overlay p {
  margin: 8px 0 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.bento__cell--feature h3 {
  font-size: 1rem;
  margin: 12px 0 8px;
}

.bento__icon {
  width: 36px;
  height: 36px;
}

.bento__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.bento__tags span {
  font-size: 0.7rem;
  padding: 3px 8px;
  background: #eef5fa;
  color: #0677b9;
  border-radius: 6px;
}

.bento__cell--wide {
  grid-column: span 2;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.bento__cell--wide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.bento__caption {
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bento__caption h3 {
  margin: 0 0 8px;
}

.bento__caption p {
  margin: 0;
  color: #666;
  font-size: 0.95rem;
  line-height: 1.5;
}

.bento__cell--cta {
  background: linear-gradient(135deg, #0677b9, #055a8c);
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}

.bento__cell--cta h3 {
  margin: 0 0 16px;
}

.bento__btn {
  background: #fff;
  color: #0677b9;
  border: none;
  padding: 10px 20px;
  border-radius: 999px;
  font-weight: 600;
  cursor: pointer;
}

.bento__cell--stat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #0677b9;
  color: #fff;
}

.bento__stat-num {
  font-size: 3rem;
  font-weight: 800;
  line-height: 1;
}

.bento__stat-label {
  font-size: 0.85rem;
  opacity: 0.9;
}

@media (max-width: 900px) {
  .bento {
    grid-template-columns: 1fr 1fr;
  }
  .bento__cell--hero,
  .bento__cell--wide {
    grid-column: span 2;
  }
}

@media (max-width: 500px) {
  .bento {
    grid-template-columns: 1fr;
  }
  .bento__cell--hero,
  .bento__cell--wide {
    grid-column: span 1;
  }
  .bento__cell--wide {
    grid-template-columns: 1fr;
  }
}
</style>
